<btn
  [label]="providerLabel"
  [title]="'company-register.load' | translate: { register: providerLabel }"
  [icon]="'far-search'"
  [classes]="['btn-search', 'company-register-lookup-button']"
  [btnDisabled]="isLoading"
  [isLoading]="isLoading"
  [dataCyAttribute]="'company-register-load'"
  (onEvent)="lookup()"
></btn>
